import { IAPIResponseError, IError } from '@checkout/errors';
import { ISelectionStatePayload } from '@checkout/payloadTypes';
import { RootState } from '@checkout/state';
import { AxiosResponse } from 'axios';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/concat';
import 'rxjs/add/operator/switchMap';
import { fromPromise as fromPromise$ } from 'rxjs/observable/fromPromise';
import { of as of$ } from 'rxjs/observable/of';
import { RootAction } from '../actions/actionTypes.d';
import ActionTypes from './../actions/actionTypes';
import {
  // fetchSelectionError,
  fetchSelectionSuccess,
  preselectInitialValues,
  responseError,
  setErrors } from './../reducers/checkout';
import { rest } from './../utils/apiUtils';
import convertMessages from './../utils/convertErrors';
import { logger } from './../utils/logger';
import { getUrlVars } from './../utils/utils';

export const fetchSelectionEpic: Epic<RootAction, RootAction, RootState> = (action$, state$): Observable<RootAction> =>
  action$.ofType(ActionTypes.FETCH_SELECTION_REQUEST)
    .switchMap((action) => {
      const selection = getUrlVars().get('selection');

      if (selection) {
        return fromPromise$(rest.httpPut(`/selection/${selection}`));
      } else {
        return fromPromise$(rest.httpGet('/selection'));
      }
    })
    .switchMap((payload: AxiosResponse<ISelectionStatePayload>) => {
      if (!state$.value.checkout.token) {
        return Observable.concat([
          fetchSelectionSuccess(payload.data),
          preselectInitialValues(payload.data)
        ]);
      }
      return of$(fetchSelectionSuccess(payload.data));
    })
    .catch((error: IError) => {
      logger(error);
      if (error.response && error.response.data) {
        const convertedMessages = convertMessages(error.response.data, state$.value.checkout.intlData);
        const responseApiErrorPayload: IAPIResponseError = {
          errors: convertedMessages,
          selection: error.response.data.selection,
          unavailable: error.response.data.unavilable,
        };
        return of$(responseError(responseApiErrorPayload));
      }
      return of$(setErrors(error));
    });



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/selection.ts